import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetTransport, ITransport } from '../models/homepageManagementTrafficInfo.model';

const uri = '/mgmt/homepage-management/traffic-info';

export const getTransport = (campusCode: string): AxiosPromise<IGetTransport> => {
  return axios.get(`${uri}/${campusCode}`);
};

export const createTransport = (data: ITransport): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateTransport = (campusCode: string, data: ITransport): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}`, data);
};
